import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { includes, isEmpty, pull, remove } from 'lodash'
import {
  MenuRoute,
  MenuRouteGroupName,
  MenuRouteGroup
} from '../routes/menuRoutes'
import menuRouteUtil from '../utils/menuRoute.util'
import Heading from './Heading'
import Checkbox from './Checkbox'
import Label, { LabelProps } from './Label'

interface PermissionPickerProps {
  allowed: string[]
  permissions: string[]
  onChange: (permissions: string[]) => void
}

export default class PermissionPicker extends Component<PermissionPickerProps> {
  permissionGroupNames: MenuRouteGroupName[] = ['dashboard', 'receiving', 'production', 'inventory', 'shipping', 'report', 'management']

  constructor (props: PermissionPickerProps) {
    super(props)
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
  }

  handleCheckboxChange (name: string) {
    const { permissions } = this.props
    const isInclude = includes(permissions, name)
    if (isInclude) pull(permissions, name)
    else permissions.push(name)
    this.props.onChange(permissions)
  }

  permission (subsidiary: MenuRoute) {
    const checked = includes(this.props.permissions, subsidiary.name)
    return (subsidiary.text && subsidiary.name) &&
      <div
        className="mb-1 flex"
        key={subsidiary.name}>
        <Checkbox
          name={subsidiary.name}
          label={subsidiary.text}
          checked={checked}
          onChange={this.handleCheckboxChange} />
        {this.label(subsidiary)}
      </div>
  }

  label (subsidiary: MenuRoute) {
    const administrative: LabelProps = {
      type: 'danger',
      text: 'administrative',
      size: 'regular'
    }
    const advanced: LabelProps = {
      type: 'warning',
      text: 'advanced',
      size: 'regular'
    }
    const label = subsidiary.administrative
      ? administrative
      : subsidiary.advanced
        ? advanced
        : null
    return label &&
      <div className="ml-1">
        <Label
        type={label.type}
        text={label.text}
        size={label.size} />
      </div>
  }

  allowedSubsidiaries (subsidiaries: MenuRoute[]) {
    remove(subsidiaries, subsidiary => {
      return !includes(this.props.allowed, subsidiary.name)
    })
    return isEmpty(subsidiaries) ? null : subsidiaries
  }

  permissions (subsidiaries: MenuRoute[]) {
    return subsidiaries.map(subsidiary => this.permission(subsidiary))
  }

  permissionGroup (group: MenuRouteGroup) {
    const routes = menuRouteUtil.getCombinedSubsidiaries(group.name)
    const subsidiaries = this.allowedSubsidiaries(routes)
    return subsidiaries &&
      <div
        className="mb-4"
        key={group.name}>
        <div className="font-medium mb-2 capitalize">
          {group.name}
        </div>
        {this.permissions(subsidiaries)}
      </div>
  }

  permissionGroups (routes: MenuRouteGroup[]) {
    return routes.map(route => this.permissionGroup(route))
  }

  get groupColumns () {
    return menuRouteUtil.toGroupColumns([4, 3])
  }

  get columns () {
    return (
      this.groupColumns.map((groups, index) => (
        <div key={index}>
          {this.permissionGroups(groups)}
        </div>
      ))
    )
  }

  render () {
    return (
      <div>
        <Heading
          className="mb-3"
          text={i18n("Permissions")} />
        <div className="grid grid-cols-2 gap-4">
          {this.columns}
        </div>
      </div>
    )
  }
}
